if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.bulkOrder = this.form.dataset.bulkOrder == 'true';
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      document.querySelector('product-info').checkCartAndInventory();

      if (this.bulkOrder) {
        this.form.addEventListener('submit', this.onSubmitHandlerBulk.bind(this));
      } else {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }

    getSubmitButtons() {
      return document.querySelectorAll('[type="submit"]');
    }

    setSubmitButtonsLoading(loading = true) {
      const submitButtons = this.getSubmitButtons();
      submitButtons.forEach((button) => {
        button.disabled = loading;
        if (loading) {
          button.classList.add('button--loading');
        } else {
          button.classList.remove('button--loading');
          button.removeAttribute('disabled');
        }
      });
    }

    onSubmitHandlerBulk(evt) {
      evt.preventDefault();

      this.setSubmitButtonsLoading(true);

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      // Partner discount - set additional product properties that will grant discounts - for the discount to work, this requires Shopify functions
      let partnerPropertiesObject = {};
      if (this.form.querySelector('[data-partner-input-info]')) {
        const partnerInputs = Array.from(this.form.querySelectorAll('[data-partner-input-info]'));
        const checkedProperties = partnerInputs.filter((input) =>
          input.type === 'radio' ? input.checked : input.value.trim() !== ''
        );

        // Create an object with all the properties if both partner name and restaurant are provided
        if (checkedProperties.length === 2) {
          // Set all the regular properties to be added to the selected variants
          checkedProperties.forEach((input) => {
            const propertyName = input.name.replace('properties[', '').replace(']', '');
            partnerPropertiesObject[propertyName] = input.value;
          });

          // Also get the discount amount and type from the hidden inputs
          const discountAmountInput = this.form.querySelector(
            '[data-partner-discount-amount-input]'
          );
          const discountTypeInput = this.form.querySelector('[data-partner-discount-type-input]');

          if (discountAmountInput && discountAmountInput.value) {
            const discountAmountName = discountAmountInput.name
              .replace('properties[', '')
              .replace(']', '');
            // Convert discount amount to a number if it's a valid number
            const numValue = parseFloat(discountAmountInput.value);
            partnerPropertiesObject[discountAmountName] = !isNaN(numValue)
              ? numValue
              : discountAmountInput.value;
          }

          if (discountTypeInput && discountTypeInput.value) {
            const discountTypeName = discountTypeInput.name
              .replace('properties[', '')
              .replace(']', '');
            partnerPropertiesObject[discountTypeName] = discountTypeInput.value;
          }
        }
      }

      // Build up the array for the cart
      const allItems = [];
      // push all the variant IDs and quantities to the array
      if (this.form.querySelector('[data-bulk-variant-id]')) {
        this.form.querySelectorAll('[data-bulk-variant-id]').forEach((elem) => {
          if (elem.value > 0) {
            // push the respective/existent Variant notes
            const variantNote = this.form.querySelector(
              `[data-variant-id-note="${elem.dataset.bulkVariantId}"]`
            );
            let variantNotePropertyName, variantNotePropertyValue;
            if (variantNote) {
              variantNotePropertyName = variantNote
                .querySelector('[data-variant-input-note]')
                .getAttribute('name')
                .replace('properties[', '')
                .replace(']', '');

              if (variantNote.querySelector('[data-variant-input-note]').value)
                variantNotePropertyValue = variantNote.querySelector(
                  '[data-variant-input-note]'
                ).value;
            }

            allItems.push({
              id: elem.dataset.bulkVariantId,
              quantity: elem.value,
              properties: {
                [variantNotePropertyName]: variantNotePropertyValue,
                ...partnerPropertiesObject,
              },
            });
          }
        });
      }

      // The array of items is complete, make sure we send extra data to rerender applicable sections
      const body = JSON.stringify({
        items: allItems,
        sections: sectionsToFetch,
        sections_url: window.location.pathname,
      });

      // This part has been taken over from product-form.js
      // A bit of duplicate code, but otherwise really custom for this plugin
      fetch(window.Shopify.routes.root + 'cart/add.js', { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          // Open Cart drawer & close the Purchase drawer - set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            document
              .querySelector('body')
              .classList.remove(
                'purchase-drawer-is-open',
                'variant-notes-drawer-is-open',
                'shop-the-look-drawer-is-open'
              );
            this.cartDrawer.open();
          });

          // reset all the variant note fields on form submission
          this.form
            .querySelectorAll('[data-variant-input-note]')
            .forEach((input) => (input.value = ''));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setSubmitButtonsLoading(false);
          document.querySelector('product-info').checkCartAndInventory();
        });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.setSubmitButtonsLoading(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          // Open Cart drawer & close the Purchase drawer - set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            document
              .querySelector('body')
              .classList.remove('purchase-drawer-is-open', 'shop-the-look-drawer-is-open');
            this.cartDrawer.open();
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setSubmitButtonsLoading(false);
          document.querySelector('product-info').checkCartAndInventory();
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
